/**
 * @fileoverview Mock backend for the banking feature.
 * @description Registers GET /banking/data on the feature's shared mock adapter (see
 * banking-mock-adapter.ts) — the one endpoint every banking page ultimately reads through, via
 * `useBankingData()` and `lib/derived.ts`'s selectors. Unlike the sales feature's per-domain
 * endpoints, there's a single full-payload endpoint here because that's the real shape this data
 * has: one coherent, internally cross-referenced financial dataset (see `banking.types.ts`'s
 * `BankDataPayload`), not several independent domains that happen to share a page. `bank-data.json`
 * is ported directly from the InsightBox Banking design system's own fixture. A no-op when
 * VITE_ENABLE_MOCK_API is false.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import bankData from './bank-data.json'
import { bankingMockAdapter } from './banking-mock-adapter'

import type { BankDataPayload } from '@/features/banking/types/banking.types'

if (bankingMockAdapter) {
  bankingMockAdapter.onGet('/banking/data').reply(() => {
    return [200, bankData as BankDataPayload]
  })
}
